"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Card_1 = require("@/components/dataCard/Card");
const Loading_1 = require("@/components/layout/Loading");
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
var AmountSize;
(function (AmountSize) {
    AmountSize[AmountSize["Big"] = 0] = "Big";
    AmountSize[AmountSize["Medium"] = 1] = "Medium";
    AmountSize[AmountSize["Small"] = 2] = "Small";
})(AmountSize || (AmountSize = {}));
const LinkCard = ({ data }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(LinkCardContainer, { sx: { gridColumn: 'span 12', position: 'relative' } },
        react_1.default.createElement(GridContainer, null, data.children.map((e, i) => {
            return (react_1.default.createElement(Card_1.Card, { hover: true, bg: "bg", horizontal: true, radius: 200, amountSize: AmountSize.Small, isborder: false, data: e, key: `${e.title}-${i}`, cardwidth: {
                    xs: 12,
                    sm: 12,
                    md: 6,
                    lg: 6,
                    xl: 4,
                } }));
        }))));
};
const LinkCardContainer = (0, styled_components_1.default)(material_1.Box) ``;
const TotalSupplyCards = ({ data, isPageLoading, assets }) => {
    if (!isPageLoading && data) {
        return (react_1.default.createElement(NesteDataCardContainer, null,
            react_1.default.createElement(Card_1.Card, { radius: 30, amountSize: AmountSize.Big, isborder: false, data: data, key: `${data.title}`, cardwidth: {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                } }),
            react_1.default.createElement(GridContainer, null, data?.children?.map((e, i) => {
                return (react_1.default.createElement(Card_1.Card, { radius: 20, amountSize: AmountSize.Medium, key: `${e.title}-${i}`, isborder: true, bg: 'bg', data: e, cardwidth: {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 6,
                        xl: 6,
                    }, wallet: assets &&
                        e.name === 'ORIGYN Foundation' && {
                        payload: (react_1.default.createElement(react_1.default.Fragment, null, assets.children.map((e, i) => (react_1.default.createElement(Card_1.Card, { key: `${e.title}-${i}`, radius: 15, isborder: true, data: e, horizontal: true, margin: "5px 0", cardwidth: {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }, bg: 'bg' }))))),
                    } }, e.children?.map((e, i) => {
                    return (react_1.default.createElement(Card_1.Card, { radius: 20, amountSize: AmountSize.Small, key: `${e.title}-${i}`, data: e, isborder: false, cardwidth: {
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 6,
                            xl: 6,
                        }, bg: "contrastBg" }));
                })));
            }))));
    }
    else if (!data || isPageLoading) {
        return (react_1.default.createElement(NesteDataCardContainer, null,
            react_1.default.createElement(material_1.Box, { sx: { gridColumn: 'span 12', height: '400px' } },
                react_1.default.createElement(Loading_1.Loading, null))));
    }
};
exports.default = TotalSupplyCards;
const NesteDataCardContainer = (0, styled_components_1.default)('div') `
  background: ${(props) => props.theme.colors.gradientBg};
  column-gap: 15px;
  row-gap: 0;
  display: grid;
  grid-column: span 12;
  grid-template-columns: repeat(12, 1fr);
  padding: ${(props) => props.theme.spacing.margin.md};
  border-radius: 30px;
  ${(props) => props.theme.media.lg} {
    padding: ${(props) => props.theme.spacing.margin.md};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.md} {
    padding: ${(props) => props.theme.spacing.margin.md};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.sm} {
    padding: ${(props) => props.theme.spacing.margin.sm};
    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    padding: ${(props) => props.theme.spacing.margin.xs};
    grid-column: span 12;
  }
`;
const SecondaryLabel = (0, styled_components_1.default)(material_1.Box) `
  grid-column: span 12;
  color: ${(props) => props.theme.colors.onBg};
  font-weight: 400;
  padding: 15px 0 10px 0;
`;
const GridContainer = (0, styled_components_1.default)('div') `
  display: grid;
  grid-column: span 12;
  width: 100%;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 15px;
  row-gap: 15px;
  height: fit-content;
  ${(props) => props.theme.media.lg} {
  }
  ${(props) => props.theme.media.md} {
    row-gap: 10px;
  }
  ${(props) => props.theme.media.sm} {
  }
  ${(props) => props.theme.media.xs} {
  }
`;
const ThemedIconButton = (0, styled_components_1.default)(material_1.IconButton) `
  color: ${(props) => props.theme.colors.onBg} !important;
`;
